document.addEventListener("DOMContentLoaded", () => {
  console.log("EcoEdge theme JS loaded");

  const colorModeKey = "ecoedge-color-mode";
  const themeSwitcher = document.querySelector("[data-theme-switch]");
  const systemPreference = window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;

  const setSwitchState = (mode) => {
    if (!themeSwitcher) return;
    themeSwitcher.querySelectorAll("[data-mode]").forEach((btn) => {
      const isActive = btn.dataset.mode === mode;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  };

  const resolveTheme = (mode) => {
    if (mode === "dark" || mode === "light") return mode;
    return systemPreference && systemPreference.matches ? "dark" : "light";
  };

  const applyColorMode = (mode) => {
    const resolved = resolveTheme(mode);
    document.documentElement.dataset.themeMode = mode;
    document.documentElement.dataset.theme = resolved;
    try {
      localStorage.setItem(colorModeKey, mode);
    } catch (error) {
      console.warn("Unable to persist color mode", error);
    }
    setSwitchState(mode);
  };

  const initColorMode = () => {
    let stored = "auto";
    try {
      stored = localStorage.getItem(colorModeKey) || "auto";
    } catch (error) {
      stored = "auto";
    }

    if (!["light", "dark", "auto"].includes(stored)) {
      stored = "auto";
    }

    applyColorMode(stored);

    if (themeSwitcher) {
      themeSwitcher.querySelectorAll("[data-mode]").forEach((btn) => {
        btn.addEventListener("click", () => {
          applyColorMode(btn.dataset.mode || "auto");
        });
      });
    }

    const syncSystemPreference = () => {
      const mode = document.documentElement.dataset.themeMode || "auto";
      if (mode === "auto") {
        applyColorMode("auto");
      }
    };

    if (systemPreference?.addEventListener) {
      systemPreference.addEventListener("change", syncSystemPreference);
    } else if (systemPreference?.addListener) {
      systemPreference.addListener(syncSystemPreference);
    }
  };

  initColorMode();

  document.querySelectorAll("[data-qty]").forEach((stepper) => {
    const input = stepper.querySelector(".qty-input");
    stepper.querySelectorAll(".qty-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const delta = Number(btn.dataset.change || 0);
        const current = Number(input.value) || 1;
        const next = Math.max(1, current + delta);
        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  });

  const mainFrame = document.querySelector("[data-main-frame]");
  const thumbs = document.querySelectorAll("[data-gallery-thumbs] .product-thumb");
  if (mainFrame && thumbs.length) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const src = thumb.dataset.src;
        const alt = thumb.dataset.alt;
        const id = thumb.dataset.mediaId;
        const type = thumb.dataset.mediaType;
        if (!src || !id || !type) return;

        // Swap main media
        mainFrame.innerHTML = "";
        mainFrame.dataset.mediaType = type;
        mainFrame.dataset.mediaId = id;

        if (type === "image") {
          const img = document.createElement("img");
          img.src = src;
          img.alt = alt || "";
          img.id = "product-main-media";
          mainFrame.appendChild(img);
        } else if (type === "video" || type === "external_video") {
          const video = document.createElement("video");
          video.src = src;
          video.controls = true;
          video.autoplay = false;
          video.loop = false;
          video.muted = true;
          video.className = "product-main-media-video";
          mainFrame.appendChild(video);
        } else if (type === "model") {
          const model = document.createElement("model-viewer");
          model.src = src;
          model.alt = alt || "";
          model.setAttribute("reveal", "interaction");
          model.setAttribute("camera-controls", "");
          model.setAttribute("auto-rotate", "");
          model.setAttribute("ar", "");
          model.setAttribute("shadow-intensity", "1");
          model.className = "product-main-media-model";
          mainFrame.appendChild(model);
        }

        thumbs.forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  }

  const cartForm = document.querySelector(".cart__form");
  if (cartForm) {
    cartForm.querySelectorAll(".qty-input").forEach((input) => {
      input.addEventListener("change", () => {
        cartForm.submit();
      });
    });
  }

  const scrollBtn = document.querySelector(".btn-scroll-top");
  if (scrollBtn) {
    const toggleVisibility = () => {
      if (window.scrollY > 320) {
        scrollBtn.classList.add("is-visible");
      } else {
        scrollBtn.classList.remove("is-visible");
      }
    };
    toggleVisibility();
    window.addEventListener("scroll", toggleVisibility);
    scrollBtn.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  const consentKey = "ecoedge-cookie-consent";
  const consentControls = {
    container: document.querySelector("[data-cookie-preferences]"),
    banner: document.querySelector("[data-cookie-banner]"),
    modal: document.querySelector("[data-cookie-modal]"),
    openers: document.querySelectorAll("[data-cookie-open]"),
    closers: document.querySelectorAll("[data-cookie-close]"),
    acceptAll: document.querySelectorAll("[data-cookie-accept-all]"),
    reject: document.querySelectorAll("[data-cookie-reject]"),
    save: document.querySelector("[data-cookie-save]"),
    analyticsToggle: document.querySelector('[data-cookie-toggle="analytics"]'),
    marketingToggle: document.querySelector('[data-cookie-toggle="marketing"]'),
    preferencesToggle: document.querySelector('[data-cookie-toggle="preferences"]'),
  };

  const consentState = {
    analytics: false,
    marketing: false,
    preferences: false,
  };

  let hasUserChoice = false;

  const hideLegacyBanner = () => {
    const legacySelectors = [
      "[data-tracking-consent-banner]",
      ".shopify-policy-banner",
      ".shopify-pc__banner",
      "#shopify-pc__banner",
    ];
    legacySelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        el.style.setProperty("display", "none", "important");
      });
    });
  };

  const consentApiPromise = new Promise((resolve) => {
    if (window.Shopify?.customerPrivacy) {
      resolve(window.Shopify.customerPrivacy);
      return;
    }

    if (window.Shopify?.loadFeatures) {
      Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1",
          },
        ],
        (error) => {
          if (error) {
            console.warn("Consent API unavailable", error);
            resolve(null);
            return;
          }
          resolve(window.Shopify?.customerPrivacy || null);
        }
      );
    } else {
      resolve(null);
    }
  });

  const ensureConsentApi = () => consentApiPromise;

  const updateToggleUI = () => {
    if (consentControls.analyticsToggle) {
      consentControls.analyticsToggle.checked = !!consentState.analytics;
    }
    if (consentControls.marketingToggle) {
      consentControls.marketingToggle.checked = !!consentState.marketing;
    }
    if (consentControls.preferencesToggle) {
      consentControls.preferencesToggle.checked = !!consentState.preferences;
    }
  };

  const showBanner = () => {
    if (consentControls.banner) {
      consentControls.banner.hidden = false;
    }
  };

  const hideBanner = () => {
    if (consentControls.banner) {
      consentControls.banner.hidden = true;
    }
  };

  const openModal = () => {
    if (consentControls.modal) {
      updateToggleUI();
      consentControls.modal.hidden = false;
    }
  };

  const closeModal = () => {
    if (consentControls.modal) {
      consentControls.modal.hidden = true;
    }
  };

  const persistLocal = () => {
    try {
      localStorage.setItem(consentKey, JSON.stringify(consentState));
    } catch (error) {
      console.warn("Unable to persist cookie preferences", error);
    }
  };

  const applyConsent = (reason) => {
    persistLocal();
    ensureConsentApi().then((api) => {
      if (!api?.setTrackingConsent) return;
      api.setTrackingConsent(
        {
          analytics: !!consentState.analytics,
          marketing: !!consentState.marketing,
          preferences: !!consentState.preferences,
        },
        () => {},
        reason || "preferences"
      );
    });
    updateToggleUI();
    hideBanner();
    closeModal();
    hasUserChoice = true;
  };

  const saveFromModal = () => {
    consentState.analytics = !!consentControls.analyticsToggle?.checked;
    consentState.marketing = !!consentControls.marketingToggle?.checked;
    consentState.preferences = !!consentControls.preferencesToggle?.checked;
    applyConsent("preferences");
  };

  const acceptAll = () => {
    consentState.analytics = true;
    consentState.marketing = true;
    consentState.preferences = true;
    applyConsent("accept_all");
  };

  const rejectAll = () => {
    consentState.analytics = false;
    consentState.marketing = false;
    consentState.preferences = false;
    applyConsent("reject_all");
  };

  const hydrateFromStorage = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(consentKey) || "null");
      if (saved && typeof saved === "object") {
        if (typeof saved.analytics === "boolean") {
          consentState.analytics = saved.analytics;
        }
        if (typeof saved.marketing === "boolean") {
          consentState.marketing = saved.marketing;
        }
        if (typeof saved.preferences === "boolean") {
          consentState.preferences = saved.preferences;
        }
        hasUserChoice = true;
        updateToggleUI();
        hideBanner();
      }
    } catch (_error) {
      // ignore parsing issues
    }
  };

  const hydrateFromShopify = () => {
    ensureConsentApi().then((api) => {
      if (!api?.getTrackingConsent) {
        if (!hasUserChoice) showBanner();
        return;
      }
      api.getTrackingConsent((consent) => {
        // A reject-all leaves every category false, which is indistinguishable from
        // "never asked" — so only shouldShowBanner can tell those two apart.
        const mustAsk =
          typeof api.shouldShowBanner === "function"
            ? api.shouldShowBanner()
            : !(consent && (consent.preferences || consent.analytics || consent.marketing));

        if (!mustAsk) {
          if (consent) {
            consentState.analytics = !!consent.analytics;
            consentState.marketing = !!consent.marketing;
            consentState.preferences = !!consent.preferences;
          }
          hasUserChoice = true;
          persistLocal();
          updateToggleUI();
          hideBanner();
          return;
        }

        if (hasUserChoice) {
          // localStorage holds a choice Shopify has no record of; re-assert it
          applyConsent("preferences");
          return;
        }

        showBanner();
      });
    });
  };

  const initConsentControls = () => {
    if (!consentControls.container) return;

    hideLegacyBanner();

    hydrateFromStorage();
    hydrateFromShopify();

    consentControls.openers.forEach((btn) => {
      btn.addEventListener("click", openModal);
    });

    consentControls.closers.forEach((btn) => {
      btn.addEventListener("click", closeModal);
    });

    consentControls.acceptAll.forEach((btn) => {
      btn.addEventListener("click", acceptAll);
    });

    consentControls.reject.forEach((btn) => {
      btn.addEventListener("click", rejectAll);
    });

    if (consentControls.save) {
      consentControls.save.addEventListener("click", saveFromModal);
    }

    if (!hasUserChoice) {
      showBanner();
    }
  };

  initConsentControls();
});
